// Theme
import '@styles/index.css'

import businessCard from '@scripts/components/business-card'

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.documentElement.classList.remove('_preload')
  }, 250)
})

const pageHas = (selector) => {
  return document.querySelectorAll(selector).length;
};

const loadComponents = async () => {
  if (pageHas("[data-business-card]")) {
    const { default: component } = await import(
      /* webpackChunkName: "components-business-card" */ "@scripts/components/business-card"
    );

    component.init();
  }
  if (pageHas("[data-modal]")) {
    const { default: component } = await import(
      /* webpackChunkName: "components-modal" */ "@scripts/components/modal"
    );

    component.init();
  }

};
loadComponents();
